"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationsRolloffOrderSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const combine_labels_1 = require("../../utils/combine-labels");
exports.OperationsRolloffOrderSchema = {
    name: 'operations-rolloff-order',
    alias: 'Operations Rolloff Order',
    shortName: 'Rolloff Order',
    applications: ['wayste'],
    returnType: {
        wayste: transport_types_1.Operations.RolloffOrder,
    },
    searchableAttributes: [
        {
            field: 'serviceLocation.address.addressLine1',
            alias: 'Service Location Address',
            shortName: 'Address',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.address.addressLine2',
            alias: 'Service Location Address 2',
            searchableByDefault: false,
        },
        {
            field: 'serviceLocation.address.state',
            alias: 'Service Location State',
            shortName: 'State',
            searchableByDefault: false,
        },
        {
            field: 'serviceLocation.address.city',
            alias: 'Service Location City',
            shortName: 'City',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.address.zip',
            alias: 'Service Location Zip Code',
            shortName: 'Zip',
            searchableByDefault: false,
        },
        {
            field: 'serviceLocation.address.county',
            alias: 'Service Location County',
            shortName: 'County',
            searchableByDefault: false,
        },
        {
            field: 'customer.displayName',
            alias: 'Customer Name',
            shortName: 'Name',
            searchableByDefault: true,
        },
        {
            field: 'customer.companyName',
            alias: 'Company',
            shortName: 'Company',
            searchableByDefault: true,
        },
        {
            field: 'orderNumber',
            alias: 'Order Number',
            shortName: 'Order Number',
            searchableByDefault: true,
        },
        {
            field: 'poNumber',
            alias: 'PO Number',
            shortName: 'PO Number',
            searchableByDefault: true,
        },
        {
            field: 'expectedType',
            alias: 'Container Type',
            shortName: 'Type',
            searchableByDefault: true,
        },
        {
            field: 'material',
            alias: 'Material',
            shortName: 'Material',
            searchableByDefault: true,
        },
    ],
    filterableAttributes: [
        {
            field: 'orderNumber',
            alias: 'Order Number',
            shortName: 'Order Number',
            type: 'NUMBER',
            format: 'INTEGER',
            allowedOperators: 'ALL',
        },
        {
            field: 'requestedDeliveryDate',
            alias: 'Requested Delivery Date',
            shortName: 'Delivery Date',
            type: 'DATE',
            allowedOperators: 'ALL',
            format: 'YYYY-MM-DD',
        },
        {
            field: 'requestedPickupDate',
            alias: 'Requested Pickup Date',
            shortName: 'Pickup Date',
            type: 'DATE',
            allowedOperators: 'ALL',
            format: 'YYYY-MM-DD',
        },
        {
            field: 'status',
            alias: 'Order Status',
            shortName: 'Status',
            type: 'STRING',
            allowedOperators: 'ALL',
            options: (0, combine_labels_1.combineLabels)(transport_types_1.Order.OrderStatuses.map((key) => ({
                value: String(key),
                label: transport_types_1.Order.WaysteOrderStatusLabels[key],
            }))),
            allowsMultipleValues: true,
        },
        {
            field: 'createdAt',
            type: 'TIMESTAMP',
            alias: 'Created At',
            shortName: 'Created',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            field: 'lastUpdatedAt',
            type: 'TIMESTAMP',
            alias: 'Last Updated At',
            shortName: 'Last Updated',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
    ],
    extraMappings: [],
};
//# sourceMappingURL=operations-rolloff-order.js.map